import { Fragment, type ReactNode } from 'react';

import { Link } from 'react-router-dom';

// Known Nile customers/products referenced across the Overview pages, mapped to their Data-app detail pages.
// Names are the CURRENT (re-anonymized) full catalog names — kept in sync with server/data/overviewApp.json.
// Full names only (no short aliases): every mention in the data uses the full form, and aliases otherwise cause
// partial-match links (e.g. "Appleton Woods" linking only the prefix of "Appleton Woods Distributors #2").
type Entity = { name: string; type: 'customer' | 'product'; id: string };
const ENTITIES: Entity[] = [
  { name: 'Fieldstone Wholesale #23 - Ottawa', type: 'customer', id: 'cust_65CFA91CEE6C' },
  { name: 'Appleton Woods Distributors #2', type: 'customer', id: 'cust_FEB763A6FC86' },
  { name: 'Donaukanal Handelsgesellschaft', type: 'customer', id: 'cust_282D10ED0B7C' },
  { name: 'Pufei Canteen - Shanghai', type: 'customer', id: 'cust_177852D9C7A3' },
  { name: 'Neckar Vertrieb #1', type: 'customer', id: 'cust_C0E15CD645A8' },
  { name: 'Acme® Sports Drink, Orange, 32oz Bottle', type: 'product', id: 'prod_00015D4C341C' },
  { name: 'Acme® Energy Drink, Grape Thunder, 8.4oz Can, 4-Pack', type: 'product', id: 'prod_0061FAA05937' },
];

const byName = new Map(ENTITIES.map((e) => [e.name, e]));
const escape = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
// One regex of all names, longest-first (so "NeoLab Migge GmbH" wins over "NeoLab Migge").
const RE = new RegExp(
  `(${[...ENTITIES.map((e) => e.name)]
    .sort((a, b) => b.length - a.length)
    .map(escape)
    .join('|')})`,
  'g',
);

const hrefFor = (e: Entity) =>
  e.type === 'customer'
    ? `/data/customers?id=${encodeURIComponent(e.id)}`
    : `/data/products?id=${encodeURIComponent(e.id)}`;

// Wrap any known customer/product mention in free text with a link to its detail page.
export function linkify(text: string | undefined, color = '#274483'): ReactNode {
  if (!text) return text;
  const parts = text.split(RE);
  return parts.map((part, i) => {
    const ent = byName.get(part);
    if (!ent) return <Fragment key={i}>{part}</Fragment>;
    return (
      <Link key={i} to={hrefFor(ent)} style={{ color, fontWeight: 600, textDecoration: 'none' }}>
        {part}
      </Link>
    );
  });
}
